import { SVGProps, Ref, forwardRef } from "react";

const DeskitIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    aria-hidden="true"
    data-name="Layer 1"
    viewBox="0 0 500 500"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Deskit Icon"
    {...props}
  >
    <title id="Deskit Icon">Deskit Icon</title>
    <defs>
      <style>{"\r\n      .cls-1{fill:#649bd3}.cls-2{fill:#333}\r\n    "}</style>
    </defs>
    <path
      d="M281.59 200.7v60.28c4.14-1.99 23.51-24.66 25.28-24.66h17l-28.48 27.86 30.32 33.34h-16.08c-2.07 0-23.35-27.85-28.03-30.14v28.77c0 2.24-9.88 1.14-11.95 1.37v-96.81h11.95Z"
      className="cls-1"
    />
    <path
      d="M345.49 246.37h13.79l.48 31.46 12.39-8.7v-22.76h19.3v-10.96h-19.3v-16.44h-12.87v16.44h-13.79v10.96zm-18.03 20.07v.07s.05-.04.08-.06l-.08-.02Z"
      className="cls-2"
    />
    <path
      d="M406.59 244.54c4-8.42-1.8-14.66-1.8-14.66-6.39-7.95-18.2-5.8-27.61-3.59-.22 1.58 2.09.87 3.2.9 6.41.22 13.38-1.32 15.48 6.56 2.68 10.04-5.1 20.32-15.54 30.53-4.69 4.59-55.22 47.87-52.87 2.24-2.07 1.36-3.49 4.78-4.3 7-6.6 18.16 2.2 26.03 20.38 23.9 4.18-.49 15.6-5.75 17.43-5.45.07.01.21.13.41.33 4.67 4.77 11.3 7.22 17.91 6.24 13.58-2.02 8.92-13.72 8.92-13.72l-1.94 1.28c-4.99 1.24-10.33 2.97-13.67-2.26 14.92-8.66 27.78-23.2 34.01-39.28Zm-73.58-21.42c16.53 5.1 16.28-20.22.71-16.75-7.19 1.61-8.66 14.29-.71 16.75Z"
      className="cls-2"
    />
    <path
      d="M343.83 284.14v1.09c-4.82 1.45-8.08.32-11.56-1.61v-48h11.56v48.52Z"
      className="cls-2"
    />
    <path
      d="M144.63 244.54c-1.4.06-1.15-1.74-2.27-2.76-17.59-15.91-47.7-4.1-50.11 19.66-1.52 15.05 3.88 27.7 16.31 34.1s10.07 5.91 20.88 2.88h.49c.62-.27 1.24-.53 1.84-.79.06-.02.11-.05.17-.08.18-.08.35-.16.53-.23.15-.07.29-.13.44-.19 4.27-1.88 8.13-3.91 11.26-7.84 1.22 1.33-.09 7.68.45 8.22.42.42 10.1-.32 11.95 0V200.7h-11.95v43.84-.02Zm-22.52 42.93c-22.04-2.07-22.79-37.48-2.54-40.88 32.94-5.53 32.91 43.73 2.54 40.88Z"
      className="cls-1"
    />
    <path
      d="M207.72 279.31c-1.04.18-4.21 4.37-5.65 5.41-11.13 8.07-31.21 1.29-30.79-13.7h48.71c.76-15.85-5.08-31.42-21.86-35.36-40.02-9.41-54.34 43.91-23.45 59.86-.11.01-.17.02-.17.02s2.61 1.45 6.62 2.55c.39.11.77.23 1.16.34h.15c3.92.91 8.89 1.37 14.03 0h1.44c7.34-2.38 14.91-5.7 18.87-12.8-1.91-.7-7.82-6.53-9.09-6.32Zm-.58-17.41h-35.85c1.1-22.58 35.16-23.94 35.85 0Z"
      className="cls-1"
    />
    <path
      d="M266.42 271.94c-5.38-12.59-29.2-9.39-31.53-17.09-2.76-9.15 10.84-10.2 17.01-6.84 1.65.9 3.85 3.92 5.16 3.72 1.02-.15 9.08-6.24 8.84-7.53-12.51-17.74-51.41-9.75-43.45 15.71 4.17 13.32 30.62 9.51 32.34 19.09 1.99 11.08-22.72 10.26-26.97 1.18-1.04 2.06-7.99 5.49-8.66 6.46-1.48 2.13 3.76 6.12 8.66 8.86l-.3.03s1.06.59 2.85 1.29c1.9.92 3.53 1.52 4.35 1.58h.74c3.92.91 8.89 1.37 14.03 0h.85c12.43-2.7 21.6-13.58 16.08-26.49Z"
      className="cls-1"
    />
  </svg>
);

const ForwardRef = forwardRef(DeskitIcon);
export default ForwardRef;
